import type { SVGProps } from 'react';

import { cn } from '../utils/cn';
import { Colors } from '../utils/common';

export const SVG = {
  Logo: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="89"
      height="24"
      viewBox="0 0 89 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0319 12.8773C11.0319 14.5692 10.089 16.4178 7.48034 16.4178C4.87165 16.4178 3.92875 14.6005 3.92875 12.8773V5.42037H0V12.8773C0 16.5744 2.57726 20.3342 7.48034 20.3342C12.4149 20.3342 14.9607 16.5744 14.9607 12.8773V5.42037H11.0005V12.8773H11.0319ZM86.5268 11.9687C85.7725 11.5614 84.9867 11.2794 84.2324 11.0287C83.5724 10.7781 82.9123 10.5587 82.378 10.2768C82.0323 10.0888 81.8437 9.74413 81.938 9.36815C82.0009 8.99217 82.3466 8.74151 82.7552 8.71018C82.8181 8.71018 82.8809 8.71018 82.9438 8.71018C83.981 8.71018 85.521 9.36815 86.4325 9.99478L88.6326 6.92428C86.8097 5.54569 84.9553 4.88773 82.8495 4.88773C82.7238 4.88773 82.598 4.88773 82.5038 4.88773C79.8322 4.98172 78.1036 5.953 77.4121 7.77024C76.8149 9.33681 77.0349 10.9034 78.0407 12.0627C78.6064 12.7206 79.4236 13.1593 80.2094 13.5352C80.9008 13.8799 81.6551 14.1305 82.3466 14.4125L82.6295 14.5065C82.9123 14.6005 83.2266 14.7258 83.5095 14.8512C84.0438 15.1018 84.201 15.5718 84.1067 15.9478C84.0124 16.3551 83.5724 16.6997 82.6609 16.5744C81.278 16.4178 79.3922 15.7598 77.9778 15.0705L76.312 18.4543C76.312 18.4543 78.6064 19.4256 78.7636 19.5196C79.4865 19.8016 80.3037 19.9582 81.058 20.1462C82.598 20.5222 84.2324 20.5222 85.741 20.0836C87.5954 19.5509 88.7269 18.2037 88.9469 16.3864C89.2298 14.4439 88.3812 12.9399 86.4325 11.9373L86.5268 11.9687ZM68.486 10.5587C69.5546 10.5587 70.4346 9.68146 70.4346 8.61619V7.26893C70.4346 6.20366 69.5546 5.32637 68.486 5.32637C67.4174 5.32637 66.5373 6.20366 66.5373 7.26893V8.61619C66.5373 9.68146 67.4174 10.5587 68.486 10.5587ZM64.0229 5.42037H60.4713V10.3081H64.0229V5.42037ZM71.2832 11.9373C70.9375 12.7206 69.0831 16.3864 64.9658 16.3864C60.8485 16.3864 58.9941 12.7206 58.6484 11.9373L55.1596 13.5979C56.7626 18.235 61.3514 20.3655 64.9658 20.3655C67.8574 20.3655 70.8432 19.0496 72.7919 16.9191L72.8547 16.8251L74.4262 17.6084L76.092 14.2245L71.2832 11.9373ZM51.9224 5.4517L48.6536 11.906L45.4792 5.4517H40.7647L46.2964 16.5744L43.562 21.9321L47.2707 23.6867L56.4483 5.4517H51.8909H51.9224ZM34.353 19.7076H38.6589V0H34.353V19.6762V19.7076ZM26.2441 19.9269C24.8297 19.9269 22.8496 19.7702 22.0324 18.7363C21.7181 18.329 21.7181 17.7337 21.7181 17.1697C21.7181 17.0757 21.7181 16.9504 21.7181 16.8564C22.8496 17.7024 24.2954 17.9217 25.8669 17.9217C29.5128 17.9217 31.9643 15.1958 31.9643 11.5614C31.9643 7.92689 29.5442 5.07572 25.8669 5.07572C24.3268 5.07572 22.881 5.51436 21.7496 6.36031V5.4517H17.3179C17.3179 5.4517 17.3808 16.8877 17.3808 17.4204C17.3808 18.705 17.8208 20.2089 18.6066 21.2428C20.3352 23.4674 23.1953 23.9373 25.8355 24C27.3127 24 28.8213 23.718 30.2042 23.2167C30.8328 22.9974 31.43 22.7154 31.9957 22.4021L30.0785 18.9243C28.8842 19.5509 27.5641 19.8956 26.2126 19.9269H26.2441ZM24.7354 8.99217C26.2755 8.99217 27.3755 10.0261 27.3755 11.5614C27.3755 13.0966 26.2755 14.0052 24.7354 14.0052C23.1953 14.0052 22.0953 12.9086 22.0953 11.5614C22.0953 10.2141 23.1639 8.99217 24.7354 8.99217Z"
        fill="#FF6741"
      />
    </svg>
  ),

  // TODO: 추후 SVG.Check > Checked, UnChecked로 변경 필요
  Check: ({
    isActive,
    fill,
    className,
    ...props
  }: { isActive: boolean } & SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="10"
        className={cn(
          {
            'fill-brand-1': isActive,
            'fill-gray-100': !isActive,
          },
          className,
        )}
      />
      <path
        d="M5.71802 10.9234L10.487 15.6925L18.282 7.89746"
        stroke="white"
        strokeWidth="2.7889"
      />
    </svg>
  ),

  Checked: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="10"
        className={cn('fill-gray-700', className)}
      />
      <path
        d="M5.71802 10.9234L10.487 15.6925L18.282 7.89746"
        stroke="white"
        strokeWidth="2.7889"
      />
    </svg>
  ),

  UnChecked: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="10"
        className={cn('fill-gray-300', className)}
      />
      <path
        d="M5.71802 10.9234L10.487 15.6925L18.282 7.89746"
        stroke="white"
        strokeWidth="2.7889"
      />
    </svg>
  ),

  UnCheckedError: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="9.5"
        className="fill-red-100 stroke-red-500"
      />
      <path
        d="M5.71802 10.9235L10.487 15.6925L18.282 7.89752"
        stroke="white"
        strokeWidth="2.7889"
      />
    </svg>
  ),

  ActiveRadio: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('text-brand-1', className)}
      {...props}
    >
      <circle cx="12" cy="12" r="11" fill="currentColor" />
      <circle cx="12" cy="12" r="5" fill="white" />
    </svg>
  ),

  DefaultRadio: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('text-gray-100', className)}
      {...props}
    >
      <circle cx="12" cy="12" r="11" fill="currentColor" />
    </svg>
  ),

  DefaultRadioV2: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('text-gray-200', className)}
      {...props}
    >
      <circle cx="12" cy="12" r="11" fill="currentColor" />
      <circle cx="12" cy="12" r="10" fill="white" />
    </svg>
  ),

  Minus: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      className={cn('stroke-gray-400', className)}
      {...props}
    >
      <path
        d="M1 1L6 1L11 1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Plus: ({
    className,
    pathProps,
    ...props
  }: SVGProps<SVGSVGElement> & { pathProps?: SVGProps<SVGPathElement> }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={cn('stroke-gray-400', className)}
      {...props}
    >
      <path
        d="M1 6H6M6 6L11 6M6 6V1M6 6L6 11"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </svg>
  ),

  Equal: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      className={cn('stroke-gray-400', className)}
      {...props}
    >
      <path
        d="M0.5 5H4.5L8.5 5M0.5 1L4.5 1L8.5 1"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Home: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('stroke-gray-700', className)}
      {...props}
    >
      <path
        d="M18.5 9.5L18.5 19.5L14.3214 19.5L9.67857 19.5L5.5 19.5L5.5 9.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11L12 4L21 11"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Cart: ({
    className,
    size = 24,
    strokeWidth = 2,
    ...props
  }: SVGProps<SVGSVGElement> & { size?: 24 | 30; strokeWidth?: number }) => (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-700', className)}
      {...props}
    >
      {size === 24 && (
        <path
          d="M7.73372 13.4174H18.0111L18.9111 5.88486H6.06882M7.73372 13.4174L5.53785 3.5H3M7.73372 13.4174L7.59873 16.3782M9.65961 18.4391C9.65961 19.5773 8.73692 20.5 7.59873 20.5C6.46054 20.5 5.53785 19.5773 5.53785 18.4391C5.53785 17.3009 6.46054 16.3782 7.59873 16.3782M9.65961 18.4391C9.65961 17.3009 8.73692 16.3782 7.59873 16.3782M9.65961 18.4391L14.7443 18.4391M18.8571 18.4391C18.8571 19.5773 17.9344 20.5 16.7962 20.5C15.658 20.5 14.7353 19.5773 14.7353 18.4391C14.7353 17.3009 15.658 16.3782 16.7962 16.3782C17.9344 16.3782 18.8571 17.3009 18.8571 18.4391Z"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
      {size === 30 && (
        <path
          d="M9.66715 16.7718H22.5139L23.6388 7.35607H7.58602M9.66715 16.7718L6.92231 4.375H3.75M9.66715 16.7718L9.49841 20.4728M12.0745 23.0489C12.0745 24.4716 10.9212 25.625 9.49841 25.625C8.07567 25.625 6.92231 24.4716 6.92231 23.0489C6.92231 21.6262 8.07567 20.4728 9.49841 20.4728M12.0745 23.0489C12.0745 21.6262 10.9212 20.4728 9.49841 20.4728M12.0745 23.0489L18.4304 23.0489M23.5713 23.0489C23.5713 24.4716 22.418 25.625 20.9952 25.625C19.5725 25.625 18.4191 24.4716 18.4191 23.0489C18.4191 21.6262 19.5725 20.4728 20.9952 20.4728C22.418 20.4728 23.5713 21.6262 23.5713 23.0489Z"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  ),

  Close: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-700 stroke-2', className)}
      {...props}
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Polygon: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      {...props}
    >
      <path
        d="M5.96934 7.04121C5.73467 7.3541 5.26533 7.3541 5.03067 7.04121L0.704002 1.27233C0.413938 0.885575 0.689895 0.333659 1.17333 0.333659L9.82667 0.333658C10.3101 0.333658 10.5861 0.885573 10.296 1.27232L5.96934 7.04121Z"
        fill="#C4C7CC"
      />
    </svg>
  ),

  Search: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('stroke-gray-700', className)}
      {...props}
    >
      <g clipPath="url(#clip0_304_5600)">
        <path
          d="M15.2089 15.2086C17.6406 12.7769 17.6406 8.83439 15.2089 6.40271C12.7772 3.97102 8.83464 3.97102 6.40296 6.40271C3.97127 8.83439 3.97127 12.7769 6.40296 15.2086C8.83464 17.6403 12.7772 17.6403 15.2089 15.2086ZM15.2089 15.2086L19.9974 19.9998"
          strokeWidth="1.9972"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_304_5600">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  Exclamation: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={cn('fill-gray-700', className)}
      {...props}
    >
      <g clipPath="url(#clip0_720_2567)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7.9 8V3H6.1V8H7.9ZM7.9 9.5V11.3H6.1V9.5H7.9Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_720_2567">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  RightChevron: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      className={cn('fill-gray-700', className)}
      {...props}
    >
      <path d="M0.133789 0.866251L4.26756 5.00002L0.133789 9.13378L1.00004 10L6.00006 5.00002L1.00004 0L0.133789 0.866251Z" />
    </svg>
  ),

  Chevron: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.24853 1.24234C4.57991 0.919137 5.11663 0.919137 5.44801 1.24234L10.7514 6.41499C10.9105 6.5702 11 6.78044 11 6.99994C11 7.21944 10.9105 7.42968 10.7514 7.58489L5.44801 12.7575C5.11663 13.0807 4.57991 13.0807 4.24853 12.7575C3.91716 12.4343 3.91716 11.9108 4.24853 11.5876L8.95219 6.99994L4.24853 2.41225C3.91716 2.08904 3.91716 1.56555 4.24853 1.24234Z"
        fill="currentColor"
      />
    </svg>
  ),

  /**
   * 선이 얇은 우향 셰브론 — 16px 자리에 맞춰 그려진 규격이다.
   * `Chevron`은 14px 기준이라 16px로 키우면 선이 1.6배쯤 굵어져 시안과 어긋난다.
   */
  // TODO: [PRD-3788] design-system Icon 세트로 이관 — 같은 글리프의 크기별 굵기를 Icon이 관리해야 한다 (현재 상자 크기가 md 24·lg 32뿐이라 16px 규격을 담을 자리가 없다)
  ChevronThin: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.77574 3.92437C5.54142 3.69006 5.54142 3.31005 5.77574 3.07574C6.01005 2.84142 6.39005 2.84142 6.62437 3.07574L11.1244 7.57574C11.3587 7.81005 11.3587 8.19006 11.1244 8.42437L6.62437 12.9244C6.39005 13.1587 6.01005 13.1587 5.77574 12.9244C5.54142 12.6901 5.54142 12.3101 5.77574 12.0757L9.85142 8.00005L5.77574 3.92437Z"
        fill="currentColor"
      />
    </svg>
  ),

  CTARightChevron: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-white', className)}
      {...props}
    >
      <path
        d="M1 1L7 7L1 13"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  BottomChevron: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-700', className)}
      {...props}
    >
      <path
        d="M5 8.5L12 15.5L19 8.5"
        stroke="#2F3845"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Bookmark: ({
    isActive,
    className,
    ...props
  }: { isActive: boolean } & SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-700', className)}
      {...props}
    >
      <path
        d="M6 5H18V20L12 17L6 20L6 5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  QuestionMark: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={cn('text-[#C4C7CC]', className)}
      {...props}
    >
      <rect
        x="0.7"
        y="0.7"
        width="14.6"
        height="14.6"
        rx="7.3"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M7.07187 9.53432V9.63135H8.30616V9.53432C8.31671 8.72569 8.56989 8.35372 9.18176 7.97097C9.86748 7.55588 10.2947 6.98445 10.3 6.10574C10.2947 4.82272 9.3189 4.0141 7.89473 4.0141C6.59187 4.0141 5.53693 4.75264 5.5 6.20278H6.81868C6.85561 5.48041 7.36198 5.13539 7.88418 5.13539C8.45912 5.13539 8.9233 5.52353 8.91802 6.12731C8.9233 6.66639 8.57517 7.02758 8.12682 7.32407C7.4622 7.73917 7.08242 8.15965 7.07187 9.53432ZM6.90308 11.1731C6.8978 11.6367 7.27231 12.0141 7.72594 12.0141C8.16374 12.0141 8.53824 11.6367 8.53824 11.1731C8.53824 10.7203 8.16374 10.3483 7.72594 10.3429C7.27231 10.3483 6.8978 10.7203 6.90308 11.1731Z"
        fill="currentColor"
      />
    </svg>
  ),

  New: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="8"
      viewBox="0 0 25 8"
      fill="none"
      {...props}
    >
      <path
        d="M0.649414 7.53516V0.464844H2.70996L5.26855 4.625H5.30762V0.464844H7.14355V7.53516H5.09277L2.55371 3.36523H2.48535V7.53516H0.649414Z"
        fill="#FF6741"
      />
      <path
        d="M8.3252 7.53516V0.464844H13.0127V2.19336H10.1611V3.19922H12.7393V4.73242H10.1611V5.80664H13.0908V7.53516H8.3252Z"
        fill="#FF6741"
      />
      <path
        d="M15.9912 7.53516L13.7256 0.464844H15.6982L16.958 4.95703H16.9971L18.2275 0.464844H19.8486L21.0889 4.95703H21.1279L22.3779 0.464844H24.3506L22.085 7.53516H20.2197L19.0576 3.44336H19.0186L17.8564 7.53516H15.9912Z"
        fill="#FF6741"
      />
    </svg>
  ),

  Clock: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      className={cn('stroke-white', className)}
      {...props}
    >
      <path
        d="M8.5 5V8H11.5M14.5 8C14.5 11.3137 11.8137 14 8.5 14C5.18629 14 2.5 11.3137 2.5 8C2.5 4.68629 5.18629 2 8.5 2C11.8137 2 14.5 4.68629 14.5 8Z"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Speaker: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      className={cn('fill-gray-700', className)}
      {...props}
    >
      <path d="M7.10154 0.0751799C7.19112 0.02585 7.29172 -1.25985e-05 7.39399 4.60403e-09C7.72869 4.12546e-05 8 0.271385 8 0.60609V9.39387C8 9.7286 7.72862 9.99995 7.39389 9.99991C7.29169 9.99989 7.19115 9.97404 7.10162 9.92473L3.56523 7.97726C3.24595 7.80143 3.04762 7.46581 3.04762 7.10131V2.89856C3.04762 2.53406 3.24595 2.19843 3.56523 2.0226L7.10154 0.0751799Z" />
      <path d="M2.28571 3.30765C2.28571 2.75537 1.838 2.30765 1.28571 2.30765H1C0.447716 2.30765 0 2.75537 0 3.30765V6.69222C0 7.2445 0.447715 7.69222 1 7.69222H1.28571C1.838 7.69222 2.28571 7.2445 2.28571 6.69222V3.30765Z" />
    </svg>
  ),

  CheckBrand: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      className={cn('stroke-brand-1', className)}
      {...props}
    >
      <path
        d="M1.66675 5.33337L8.33341 12L18.3334 2.00003"
        strokeWidth="3.88889"
      />
    </svg>
  ),

  /** 박스 없는 굵은 체크 글리프 — 사진 위에 얹어 선택을 표시할 때 사용 */
  CheckMark: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13.5206"
      viewBox="0 0 18 13.5206"
      fill="none"
      className={cn('fill-current', className)}
      {...props}
    >
      <path d="M18 2.76242L7.24182 13.5206L0 6.27879L2.76242 3.51636L7.24182 7.99576L15.2376 0L18 2.76242Z" />
    </svg>
  ),

  CheckCircle: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('fill-brand-1', className)}
      {...props}
    >
      <circle cx="9" cy="9" r="9" />
      <path
        d="M13.5 6L7.5 12L4.5 9"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  CoinStack: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M17 6.35294C17 7.65243 13.866 8.70588 10 8.70588C6.13401 8.70588 3 7.65243 3 6.35294M17 6.35294C17 5.05345 13.866 4 10 4C6.13401 4 3 5.05345 3 6.35294M17 6.35294V11M3 6.35294V17.6471C3 18.9466 6.13401 20 10 20C11.6278 20 13.1258 19.8132 14.3147 19.5M3 10.5882C3 11.6278 6.13401 12.4706 10 12.4706C11.0736 12.4706 12.0907 12.4056 13 12.2894M3 14.3529C3 15.3925 6.13401 16.2353 10 16.2353C10.695 16.2353 11.3663 16.2081 12 16.1573"
        stroke="#795B4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="16.5"
        cy="15.5"
        r="4.5"
        fill="#E5D7D1"
        stroke="#795B4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  GreenLevel: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.69269 0.494964L10.6962 1.5C10.853 1.65686 11.0392 1.78128 11.2441 1.86615C11.449 1.95102 11.6686 1.99468 11.8904 1.99464H13.312C13.7599 1.99464 14.1895 2.17257 14.5062 2.48929C14.8229 2.806 15.0009 3.23556 15.0009 3.68347V5.10508C15.0014 5.32719 15.0458 5.547 15.1314 5.75192C15.2171 5.95684 15.3423 6.14284 15.5 6.29927L16.505 7.30431C16.6619 7.46108 16.7864 7.64724 16.8714 7.85215C16.9563 8.05705 17 8.27669 17 8.4985C17 8.72031 16.9563 8.93994 16.8714 9.14485C16.7864 9.34975 16.6619 9.53591 16.505 9.69269L15.5 10.6962C15.3431 10.853 15.2187 11.0392 15.1339 11.2441C15.049 11.449 15.0053 11.6686 15.0054 11.8904V13.312C15.0054 13.5338 14.9617 13.7534 14.8768 13.9583C14.7919 14.1632 14.6675 14.3494 14.5107 14.5062C14.3539 14.663 14.1677 14.7874 13.9628 14.8723C13.7579 14.9572 13.5383 15.0009 13.3165 15.0009H11.8919C11.6696 15.0012 11.4495 15.0455 11.2443 15.1311C11.0391 15.2168 10.8528 15.3421 10.6962 15.5L9.69118 16.505C9.53441 16.6619 9.34825 16.7864 9.14335 16.8714C8.93844 16.9563 8.71881 17 8.497 17C8.27519 17 8.05555 16.9563 7.85065 16.8714C7.64574 16.7864 7.45958 16.6619 7.30281 16.505L6.29927 15.5C6.14247 15.3431 5.9563 15.2187 5.7514 15.1339C5.54649 15.049 5.32687 15.0053 5.10508 15.0054H3.68347C3.46169 15.0054 3.24208 14.9617 3.03718 14.8768C2.83228 14.7919 2.64611 14.6675 2.48929 14.5107C2.33247 14.3539 2.20807 14.1677 2.1232 13.9628C2.03832 13.7579 1.99464 13.5383 1.99464 13.3165V11.8919C1.99488 11.6699 1.95132 11.45 1.86644 11.2448C1.78156 11.0396 1.65704 10.8532 1.5 10.6962L0.494964 9.69269C0.338051 9.53591 0.213572 9.34975 0.128643 9.14485C0.0437138 8.93994 0 8.72031 0 8.4985C0 8.27669 0.0437138 8.05705 0.128643 7.85215C0.213572 7.64724 0.338051 7.46108 0.494964 7.30431L1.5 6.29927C1.65686 6.14247 1.78128 5.9563 1.86615 5.7514C1.95102 5.54649 1.99468 5.32687 1.99464 5.10508V3.68347C1.99464 3.23556 2.17257 2.806 2.48929 2.48929C2.806 2.17257 3.23556 1.99464 3.68347 1.99464H5.10508C5.32687 1.99468 5.54649 1.95102 5.7514 1.86615C5.9563 1.78128 6.14247 1.65686 6.29927 1.5L7.30431 0.494964C7.46108 0.338051 7.64724 0.213572 7.85215 0.128643C8.05705 0.0437138 8.27669 0 8.4985 0C8.72031 0 8.93994 0.0437138 9.14485 0.128643C9.34975 0.213572 9.53591 0.338051 9.69269 0.494964Z"
        fill="currentColor"
      />
      <path
        d="M5 8.50003L7.5 11L11.5 6.50003"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  /**
   * 색이 반전된 친환경 인증 배지 — 마크가 흰색, 안쪽 체크가 글자색이다.
   * 색이 깔린 배경 위에 얹을 때 쓴다(`GreenLevel`은 체크가 흰색이라 그런 배경에서 묻힌다).
   */
  GreenLevelInverted: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.69269 0.494964L10.6962 1.5C10.853 1.65686 11.0392 1.78128 11.2441 1.86615C11.449 1.95102 11.6686 1.99468 11.8904 1.99464H13.312C13.7599 1.99464 14.1895 2.17257 14.5062 2.48929C14.8229 2.806 15.0009 3.23556 15.0009 3.68347V5.10508C15.0014 5.32719 15.0458 5.547 15.1314 5.75192C15.2171 5.95684 15.3423 6.14284 15.5 6.29927L16.505 7.30431C16.6619 7.46108 16.7864 7.64724 16.8714 7.85215C16.9563 8.05705 17 8.27669 17 8.4985C17 8.72031 16.9563 8.93994 16.8714 9.14485C16.7864 9.34975 16.6619 9.53591 16.505 9.69269L15.5 10.6962C15.3431 10.853 15.2187 11.0392 15.1339 11.2441C15.049 11.449 15.0053 11.6686 15.0054 11.8904V13.312C15.0054 13.5338 14.9617 13.7534 14.8768 13.9583C14.7919 14.1632 14.6675 14.3494 14.5107 14.5062C14.3539 14.663 14.1677 14.7874 13.9628 14.8723C13.7579 14.9572 13.5383 15.0009 13.3165 15.0009H11.8919C11.6696 15.0012 11.4495 15.0455 11.2443 15.1311C11.0391 15.2168 10.8528 15.3421 10.6962 15.5L9.69118 16.505C9.53441 16.6619 9.34825 16.7864 9.14335 16.8714C8.93844 16.9563 8.71881 17 8.497 17C8.27519 17 8.05555 16.9563 7.85065 16.8714C7.64574 16.7864 7.45958 16.6619 7.30281 16.505L6.29927 15.5C6.14247 15.3431 5.9563 15.2187 5.7514 15.1339C5.54649 15.049 5.32687 15.0053 5.10508 15.0054H3.68347C3.46169 15.0054 3.24208 14.9617 3.03718 14.8768C2.83228 14.7919 2.64611 14.6675 2.48929 14.5107C2.33247 14.3539 2.20807 14.1677 2.1232 13.9628C2.03832 13.7579 1.99464 13.5383 1.99464 13.3165V11.8919C1.99488 11.6699 1.95132 11.45 1.86644 11.2448C1.78156 11.0396 1.65704 10.8532 1.5 10.6962L0.494964 9.69269C0.338051 9.53591 0.213572 9.34975 0.128643 9.14485C0.0437138 8.93994 0 8.72031 0 8.4985C0 8.27669 0.0437138 8.05705 0.128643 7.85215C0.213572 7.64724 0.338051 7.46108 0.494964 7.30431L1.5 6.29927C1.65686 6.14247 1.78128 5.9563 1.86615 5.7514C1.95102 5.54649 1.99468 5.32687 1.99464 5.10508V3.68347C1.99464 3.23556 2.17257 2.806 2.48929 2.48929C2.806 2.17257 3.23556 1.99464 3.68347 1.99464H5.10508C5.32687 1.99468 5.54649 1.95102 5.7514 1.86615C5.9563 1.78128 6.14247 1.65686 6.29927 1.5L7.30431 0.494964C7.46108 0.338051 7.64724 0.213572 7.85215 0.128643C8.05705 0.0437138 8.27669 0 8.4985 0C8.72031 0 8.93994 0.0437138 9.14485 0.128643C9.34975 0.213572 9.53591 0.338051 9.69269 0.494964Z"
        fill="white"
      />
      <path
        d="M5 8.50003L7.5 11L11.5 6.50003"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  StarFilled: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      className={cn('fill-brand-1', className)}
      {...props}
    >
      <path d="M5.94488 0.29573C6.15849 -0.0985761 6.73832 -0.0985772 6.95193 0.295729L8.57991 3.30083C8.66228 3.45289 8.81243 3.55913 8.98637 3.58845L12.424 4.16773C12.8751 4.24374 13.0542 4.78082 12.7352 5.10052L10.3037 7.53706C10.1807 7.66035 10.1233 7.83225 10.1485 8.00243L10.6451 11.3655C10.7102 11.8068 10.2411 12.1388 9.83033 11.942L6.69962 10.4428C6.5412 10.3669 6.35561 10.3669 6.1972 10.4428L3.06648 11.942C2.65569 12.1388 2.18659 11.8068 2.25175 11.3656L2.74836 8.00243C2.77348 7.83225 2.71613 7.66035 2.5931 7.53706L0.161608 5.10052C-0.157433 4.78081 0.0217477 4.24374 0.472807 4.16773L3.91044 3.58845C4.08438 3.55914 4.23453 3.45289 4.3169 3.30083L5.94488 0.29573Z" />
    </svg>
  ),

  ArrowRightSmall: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
      {...props}
    >
      <path
        d="M1 1L5 5L1 9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Setting: ({
    className,
    strokeWidth = 2,
    ...props
  }: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M18.3609 11.2151L20.5 9.37694L18.5768 6.12226L15.8751 7.01339L14.485 6.22926L13.9257 3.5H10.076L9.51501 6.22926L8.12492 7.01339L5.42487 6.12226L3.5 9.37694L5.64074 11.2151V12.7833L3.5 14.6215L5.42487 17.8777L8.12492 16.9866L9.51501 17.7707L10.076 20.5H13.9257L14.485 17.7707L15.8751 16.9866L18.5768 17.8777L20.5 14.6215L18.3609 12.7833V11.2151Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0008 15.2427C13.8352 15.2427 15.3223 13.7905 15.3223 11.9992C15.3223 10.2079 13.8352 8.75571 12.0008 8.75571C10.1664 8.75571 8.67932 10.2079 8.67932 11.9992C8.67932 13.7905 10.1664 15.2427 12.0008 15.2427Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  MyPage: ({
    className,
    strokeWidth = 2,
    ...props
  }: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4.82113 19.9366V18.7184C4.81387 18.1238 4.92561 17.5338 5.14979 16.9831C5.37397 16.4324 5.70606 15.9321 6.1265 15.5116C6.54694 15.0912 7.04723 14.7591 7.59794 14.535C8.14865 14.3108 8.73865 14.199 9.3332 14.2063H15.5328C16.1235 14.2051 16.7087 14.3212 17.2541 14.5481C17.7996 14.775 18.2945 15.108 18.7102 15.5279C19.1258 15.9477 19.4538 16.4459 19.6752 16.9937C19.8966 17.5414 20.0069 18.1277 19.9997 18.7184V19.9366M15.867 7.48331C15.867 9.4071 14.3075 10.9666 12.3837 10.9666C10.4599 10.9666 8.9004 9.4071 8.9004 7.48331C8.9004 5.55953 10.4599 4 12.3837 4C14.3075 4 15.867 5.55953 15.867 7.48331Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  WarningCircle: ({
    className,
    strokeWidth = 4,
    ...props
  }: SVGProps<SVGSVGElement> & { strokeWidth?: number }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={cn('stroke-[#FF4E4E]', className)}
      {...props}
    >
      <g clipPath="url(#clip0_69_22)">
        <circle cx="14" cy="14" r="12" strokeWidth={strokeWidth} />
        <path d="M23 5L4.61522 23.3848" strokeWidth={strokeWidth} />
      </g>
      <defs>
        <clipPath id="clip0_69_22">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  Trash: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('stroke-gray-600', className)}
      {...props}
    >
      <path
        d="M3.5 6H16.5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 9V13"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 9V13"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 6L14.7143 16H5.28571L4.5 6"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 3H8.5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  ArrowLeft: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0667 21.3C16.5333 20.9 16.5333 20.1 17.0667 19.7L21.7333 16.2C22.3926 15.7056 23.3333 16.176 23.3333 17L23.3333 24C23.3333 24.824 22.3926 25.2944 21.7333 24.8L17.0667 21.3Z"
        fill="#A5A3A2"
      />
    </svg>
  ),

  ArrowRight: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.2667 21.3C22.8 20.9 22.8 20.1 22.2667 19.7L17.6 16.2C16.9408 15.7056 16 16.176 16 17L16 24C16 24.824 16.9408 25.2944 17.6 24.8L22.2667 21.3Z"
        fill="#A5A3A2"
      />
    </svg>
  ),

  Membership: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="54"
      height="24"
      viewBox="0 0 54 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      {...props}
    >
      <rect x="0.5" y="0.5" width="53" height="23" rx="9.5" stroke="#FF6741" />
      <path
        d="M14.5401 11.6119H16.0028V12.6727H11.797V17.0525H10.4834V12.6727H6.35221V11.6119H13.2224C13.5124 10.1699 13.5249 9.09254 13.5249 8.14365H7.49586V7.0953H14.8218V8.04005C14.8218 9.03039 14.8218 10.116 14.5401 11.6119ZM17.5272 10.6796L17.1625 9.70994C19.2551 9.60635 20.4899 9.03867 20.7592 8.28867H17.6722V7.31492H20.8918V6.42818H22.1846V7.31492H25.425V8.28867H22.3172C22.5783 9.03867 23.8131 9.60635 25.9263 9.70994L25.541 10.6796C23.6308 10.5635 22.2053 10.0456 21.5382 9.18784C20.8752 10.0456 19.4498 10.5635 17.5272 10.6796ZM26.3573 11.0318V11.989H22.1888V12.7638H25.1722V15.25H19.1473V15.9793H25.4623V16.9489H17.8711V14.3633H23.8877V13.7044H17.8587V12.7638H20.896V11.989H16.744V11.0318H26.3573ZM34.9798 10.5925V6.45304H36.2311V17.0359H34.9798V11.6616H33.9231V16.5097H32.6925V6.65193H33.9231V10.5925H34.9798ZM31.3209 8.75276V13.3232C31.6358 13.2942 31.9383 13.261 32.2242 13.2238L32.2947 14.1727C30.6455 14.5083 28.4618 14.5497 27.1275 14.5497L26.9784 13.4724C27.2684 13.4724 27.5999 13.4724 27.9563 13.4682V8.75276H27.1897V7.70028H32.0833V8.75276H31.3209ZM30.1441 8.75276H29.1372V13.4434C29.4687 13.4351 29.8085 13.4227 30.1441 13.4061V8.75276ZM42.2514 9.78867C41.5553 11.2017 40.1009 12.279 38.3315 12.6561L37.7597 11.5704C39.9434 11.1727 41.547 9.53177 41.5553 7.89917V7.12017H42.9392V7.89917C42.9351 9.54005 44.5387 11.1809 46.7555 11.5704L46.1713 12.6561C44.3937 12.2873 42.9392 11.2141 42.2514 9.78867ZM37.4655 15.6934V14.616H47.1492V15.6934H37.4655Z"
        fill="#FF6741"
      />
    </svg>
  ),

  Level: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 1C0 0.447716 0.447715 0 1 0H16.5527C17.2521 0 17.7355 0.699538 17.4881 1.35371L15.4867 6.64629C15.4005 6.87422 15.4005 7.12578 15.4867 7.35371L17.4881 12.6463C17.7355 13.3005 17.2521 14 16.5527 14H1C0.447716 14 0 13.5523 0 13V1Z"
        fill="#FF6741"
      />
      <path d="M3.5 10V4H5.05841V8.53315H7.39603V10H3.5Z" fill="white" />
      <path
        d="M9.20081 10L7.45174 5.72376H9.01844L9.95514 8.34254H9.99659L10.9333 5.72376H12.5L10.7509 10H9.20081Z"
        fill="white"
      />
    </svg>
  ),

  Edit: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#E9E9E8"
      />
      <path
        d="M12.6 5L15 7.4L9 13.4L6 14L6.6 11L12.6 5Z"
        stroke="#212121"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  ),

  Star: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.6801 0.492884C10.0279 -0.164293 10.9721 -0.164295 11.3199 0.492882L13.9707 5.50139C14.1049 5.75482 14.3494 5.93189 14.6326 5.98074L20.2301 6.94622C20.9646 7.0729 21.2563 7.96803 20.7368 8.50087L16.7776 12.5618C16.5773 12.7673 16.4839 13.0538 16.5248 13.3374L17.3334 18.9426C17.4396 19.6781 16.6757 20.2313 16.0068 19.9034L10.9091 17.4047C10.6511 17.2782 10.3489 17.2782 10.0909 17.4047L4.99317 19.9034C4.32428 20.2313 3.56045 19.6781 3.66655 18.9426L4.47517 13.3374C4.51609 13.0538 4.42271 12.7673 4.22238 12.5618L0.26315 8.50086C-0.256348 7.96802 0.0354085 7.0729 0.769873 6.94622L6.3674 5.98075C6.65064 5.93189 6.89512 5.75482 7.02925 5.50139L9.6801 0.492884Z"
        fill="currentColor"
      />
    </svg>
  ),

  Photo: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.16 7.06L14.24 4.5H9.76L7.84 7.06H4L4 19H20L20 7.06H16.16ZM12 15.59C11.373 15.59 10.7601 15.4041 10.2388 15.0558C9.71754 14.7074 9.31123 14.2123 9.0713 13.6331C8.83138 13.0539 8.7686 12.4165 8.89091 11.8016C9.01323 11.1866 9.31514 10.6218 9.75847 10.1785C10.2018 9.73514 10.7666 9.43322 11.3816 9.31091C11.9965 9.18859 12.6339 9.25137 13.2131 9.4913C13.7924 9.73123 14.2874 10.1375 14.6358 10.6588C14.9841 11.1801 15.17 11.793 15.17 12.42C15.17 13.2607 14.836 14.067 14.2415 14.6615C13.647 15.256 12.8407 15.59 12 15.59Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  LocationPin: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="11"
      viewBox="0 0 9 11"
      fill="none"
      className={cn('fill-gray-500', className)}
      {...props}
    >
      <path d="M1.31787 1.31793C3.07517 -0.43932 5.92477 -0.439232 7.68213 1.31793C9.43947 3.07528 9.43944 5.92483 7.68213 7.68219L5.02393 10.3404C4.73446 10.6294 4.26548 10.6295 3.97607 10.3404L1.31787 7.68219C-0.43931 5.92482 -0.439429 3.07523 1.31787 1.31793ZM4.47607 2.34039C3.3715 2.34039 2.47607 3.23582 2.47607 4.34039C2.4763 5.44477 3.37164 6.34039 4.47607 6.34039C5.58035 6.34021 6.47585 5.44466 6.47607 4.34039C6.47607 3.23594 5.58049 2.34058 4.47607 2.34039Z" />
    </svg>
  ),

  /** 선물하기 아이콘 */
  Present: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.83333 15.1667H22.1667M14 22.1667V8.16667M14 8.16667L17.5 4.66667M14 8.16667L10.5 4.66667M4.66667 9.33333V20.9999C4.66667 21.6443 5.189 22.1666 5.83333 22.1666H22.1667C22.811 22.1666 23.3333 21.6443 23.3333 20.9999V9.33333C23.3333 8.689 22.811 8.16667 22.1667 8.16667H5.83333C5.189 8.16667 4.66667 8.689 4.66667 9.33333Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  DiscountArrow: ({ ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.28395 1.5L4.28395 6.96405L1.5 6.96405L7 12.5L12.5 6.96405L9.71605 6.96405V1.5L4.28395 1.5Z"
        fill="#795B4E"
      />
      <path
        d="M4.41454 6.40155L3.92749 6.28848L4.41454 6.40155ZM4.46032 6.02655L4.96028 6.03256L4.46032 6.02655ZM4.46482 5.65155L3.96485 5.64555L4.46482 5.65155ZM4.43154 5.27655L3.94028 5.36966L4.43154 5.27655ZM4.32962 4.52655L3.82978 4.51403L4.32962 4.52655ZM4.33902 4.15155L4.83886 4.16407L4.33902 4.15155ZM4.37054 3.77655L3.87558 3.70573L4.37054 3.77655ZM4.42419 3.40155L3.92923 3.33073L4.42419 3.40155ZM4.38323 3.02655L3.91302 3.19656L4.38323 3.02655ZM4.31544 2.83905L4.78565 2.66905L4.31544 2.83905ZM4.24765 2.65155L3.77744 2.82156L4.24765 2.65155ZM4.24582 2.27655L4.71748 2.44249L4.24582 2.27655ZM4.37775 1.90155L3.90609 1.73561L4.37775 1.90155ZM4.53776 1.64735L4.82703 2.05517L4.53776 1.64735ZM4.63181 1.58064L4.34254 1.17281L4.63181 1.58064ZM4.72585 1.51394L4.43658 1.10611L4.72585 1.51394ZM5.0074 1.41213L5.0994 1.9036L5.0074 1.41213ZM5.1949 1.37703L5.1029 0.885571L5.1949 1.37703ZM5.3824 1.34194L5.4744 1.8334L5.3824 1.34194ZM6.1324 1.41557L6.0375 1.90648L6.1324 1.41557ZM6.5074 1.46927L6.55375 0.971427L6.5074 1.46927ZM6.8824 1.50419L6.83605 2.00204L6.8824 1.50419ZM7.2574 1.51143L7.23019 1.01217L7.2574 1.51143ZM7.4449 1.50121L7.47211 2.00047L7.4449 1.50121ZM7.6324 1.49099L7.65961 1.99025L7.6324 1.49099ZM8.3824 1.56285L8.31021 2.05761L8.3824 1.56285ZM8.7574 1.54178L8.63235 1.05766L8.7574 1.54178ZM8.9449 1.49334L9.06994 1.97745L8.9449 1.49334ZM9.46736 1.51082L9.16098 1.90596L9.46736 1.51082ZM9.7623 1.73951L10.0687 1.34437L9.7623 1.73951ZM9.88197 2.04135L9.38737 1.96804L9.88197 2.04135ZM9.82639 2.41635L10.321 2.48966L9.82639 2.41635ZM9.81821 2.79135L9.32092 2.84335L9.81821 2.79135ZM9.80969 3.54135L9.33912 3.37236L9.80969 3.54135ZM9.67502 3.91635L10.1456 4.08534L9.67502 3.91635ZM9.58337 4.66635L10.0829 4.68794L9.58337 4.66635ZM9.56812 5.04135L10.0678 5.06041L9.56812 5.04135ZM9.56097 5.22885L9.06133 5.20979L9.56097 5.22885ZM9.55381 5.41635L9.05418 5.39729L9.55381 5.41635ZM9.5975 5.79135L9.11493 5.9222L9.5975 5.79135ZM9.69918 6.16635L10.1818 6.0355L9.69918 6.16635ZM9.77647 6.45658L10.2607 6.33187L9.77647 6.45658ZM9.80293 6.55931L10.2871 6.4346L9.80293 6.55931ZM9.82939 6.66203L9.34519 6.78674L9.82939 6.66203ZM10.0433 6.78567L10.0988 6.28875L10.0433 6.78567ZM10.2308 6.80658L10.1754 7.3035L10.2308 6.80658ZM10.4183 6.82749L10.4738 6.33057L10.4183 6.82749ZM10.7933 6.91906L10.617 7.38694L10.7933 6.91906ZM11.1683 7.06036L11.3447 6.59248L11.1683 7.06036ZM11.5433 7.09297L11.4439 6.60296L11.5433 7.09297ZM11.9183 7.01687L11.8189 6.52686L11.9183 7.01687ZM12.1314 7.02802L11.6877 7.25846L12.1314 7.02802ZM12.1569 7.07721L12.6007 6.84677L12.1569 7.07721ZM12.1825 7.1264L12.6262 6.89596L12.1825 7.1264ZM12.1162 7.34868L12.5579 7.58296L12.1162 7.34868ZM11.9326 7.69487L11.4909 7.46059L11.9326 7.69487ZM11.6753 7.9678L11.417 7.53964L11.6753 7.9678ZM11.5097 8.06764L11.2515 7.63947L11.5097 8.06764ZM11.3442 8.16747L11.6024 8.59564L11.3442 8.16747ZM11.0824 8.43599L11.5166 8.6838L11.0824 8.43599ZM10.8899 8.77334L10.4556 8.52552L10.8899 8.77334ZM10.6073 9.02126L10.4116 8.56118L10.6073 9.02126ZM10.4211 9.10051L10.6168 9.5606L10.4211 9.10051ZM10.2348 9.17976L10.4306 9.63985L10.2348 9.17976ZM9.92036 9.39597L10.2854 9.73764V9.73764L9.92036 9.39597ZM9.66399 9.66987L10.029 10.0115L9.66399 9.66987ZM9.25395 10.0554L9.58467 10.4304L9.25395 10.0554ZM9.11302 10.1797L8.78229 9.80471L9.11302 10.1797ZM8.89255 10.4893L8.4331 10.292L8.89255 10.4893ZM8.73346 10.8598L9.19291 11.0571L8.73346 10.8598ZM8.50013 11.1566L8.79364 11.5614L8.50013 11.1566ZM8.19255 11.3797L7.89904 10.9749L8.19255 11.3797ZM7.91261 11.6301L7.54238 11.2941L7.91261 11.6301ZM7.78646 11.7691L7.41623 11.4331L7.78646 11.7691ZM7.66031 11.9081L8.03054 12.2441L7.66031 11.9081ZM7.40366 12.1389L7.69136 12.5478L7.40366 12.1389ZM7.14265 12.3225L6.85494 11.9136L7.14265 12.3225ZM6.65296 12.2426L6.86868 11.7915L6.65296 12.2426ZM6.47337 12.1567L6.25766 12.6078L6.47337 12.1567ZM6.18329 11.9163L6.59 11.6254L6.18329 11.9163ZM6.07279 11.7618L5.66608 12.0526L6.07279 11.7618ZM5.96229 11.6072L6.369 11.3164L5.96229 11.6072ZM5.76403 11.2756L6.21204 11.0536L5.76403 11.2756ZM5.5885 10.9214L5.14049 11.1434L5.5885 10.9214ZM5.35043 10.6293L5.04666 11.0264L5.35043 10.6293ZM5.20011 10.5143L5.50388 10.1172L5.20011 10.5143ZM5.0498 10.3994L4.74604 10.7965L5.0498 10.3994ZM4.77959 10.1392L5.1651 9.8208L4.77959 10.1392ZM4.65968 9.99402L4.27417 10.3124L4.65968 9.99402ZM4.53978 9.84884L4.92529 9.53045L4.53978 9.84884ZM4.24143 9.61664L4.02226 10.066L4.24143 9.61664ZM3.88455 9.44259L3.66538 9.892L3.88455 9.44259ZM3.6148 9.18198L3.17229 9.41475L3.6148 9.18198ZM3.52349 9.00839L3.08098 9.24116L3.52349 9.00839ZM3.43218 8.8348L2.98967 9.06757L3.43218 8.8348ZM3.17769 8.55904L2.91234 8.98282L3.17769 8.55904ZM3.0145 8.45686L3.27984 8.03308L3.0145 8.45686ZM2.85131 8.35468L2.58597 8.77846L2.85131 8.35468ZM2.58324 8.0924L2.16499 8.36638L2.58324 8.0924ZM2.37348 7.77219L1.95523 8.04617L2.37348 7.77219ZM2.12225 7.49317L1.80694 7.88121L2.12225 7.49317ZM1.82957 7.25534L2.14488 6.8673L1.82957 7.25534ZM1.76206 7.07281L1.44805 6.68371L1.76206 7.07281ZM1.91974 6.94555L2.23376 7.33465L1.91974 6.94555ZM2.18608 6.91374L2.2697 6.42078L2.18608 6.91374ZM2.56108 6.97735L2.47745 7.47031L2.56108 6.97735ZM2.93608 6.97144L3.03468 7.46162L2.93608 6.97144ZM3.31108 6.89601L3.21247 6.40583L3.31108 6.89601ZM3.68608 6.85761L3.6879 7.3576L3.68608 6.85761ZM3.87358 6.85692L3.8754 7.35692L3.87358 6.85692ZM4.06108 6.85624L4.05926 6.35624L4.06108 6.85624ZM4.25742 6.88268L4.73279 6.72769L4.25742 6.88268ZM4.26626 6.90981L3.79089 7.0648L4.26626 6.90981ZM4.32748 6.77655L4.81453 6.88962L4.32748 6.77655ZM4.37101 6.58905L4.85806 6.70212L4.90158 6.51462L4.41454 6.40155L3.92749 6.28848L3.88396 6.47598L4.37101 6.58905ZM4.41454 6.40155L4.90158 6.51462C4.93854 6.35544 4.95833 6.19455 4.96028 6.03256L4.46032 6.02655L3.96035 6.02055C3.9593 6.10855 3.94857 6.19767 3.92749 6.28848L4.41454 6.40155ZM4.46032 6.02655L4.96028 6.03256L4.96253 5.84506L4.46257 5.83905L3.9626 5.83305L3.96035 6.02055L4.46032 6.02655ZM4.46257 5.83905L4.96253 5.84506L4.96478 5.65756L4.46482 5.65155L3.96485 5.64555L3.9626 5.83305L4.46257 5.83905ZM4.46482 5.65155L4.96478 5.65756C4.96669 5.49873 4.95256 5.34053 4.92279 5.18345L4.43154 5.27655L3.94028 5.36966C3.95789 5.46257 3.96595 5.55438 3.96485 5.64555L4.46482 5.65155ZM4.43154 5.27655L4.92279 5.18345L4.88725 4.99595L4.396 5.08905L3.90474 5.18216L3.94028 5.36966L4.43154 5.27655ZM4.396 5.08905L4.88725 4.99595L4.85172 4.80845L4.36046 4.90155L3.86921 4.99466L3.90474 5.18216L4.396 5.08905ZM4.36046 4.90155L4.85172 4.80845C4.83451 4.71764 4.82724 4.62804 4.82947 4.53907L4.32962 4.52655L3.82978 4.51403C3.82575 4.67506 3.83904 4.83546 3.86921 4.99466L4.36046 4.90155ZM4.32962 4.52655L4.82947 4.53907L4.83416 4.35157L4.33432 4.33905L3.83448 4.32654L3.82978 4.51403L4.32962 4.52655ZM4.33432 4.33905L4.83416 4.35157L4.83886 4.16407L4.33902 4.15155L3.83917 4.13904L3.83448 4.32654L4.33432 4.33905ZM4.33902 4.15155L4.83886 4.16407C4.8415 4.05877 4.85035 3.95324 4.8655 3.84737L4.37054 3.77655L3.87558 3.70573C3.85496 3.84986 3.8428 3.99433 3.83917 4.13904L4.33902 4.15155ZM4.37054 3.77655L4.8655 3.84737L4.89233 3.65987L4.39737 3.58905L3.90241 3.51823L3.87558 3.70573L4.37054 3.77655ZM4.39737 3.58905L4.89233 3.65987L4.91915 3.47237L4.42419 3.40155L3.92923 3.33073L3.90241 3.51823L4.39737 3.58905ZM4.42419 3.40155L4.91915 3.47237C4.94926 3.26198 4.92497 3.05439 4.85344 2.85655L4.38323 3.02655L3.91302 3.19656C3.93188 3.24871 3.9349 3.29112 3.92923 3.33073L4.42419 3.40155ZM4.38323 3.02655L4.85344 2.85655L4.78565 2.66905L4.31544 2.83905L3.84523 3.00906L3.91302 3.19656L4.38323 3.02655ZM4.31544 2.83905L4.78565 2.66905L4.71786 2.48155L4.24765 2.65155L3.77744 2.82156L3.84523 3.00906L4.31544 2.83905ZM4.24765 2.65155L4.71786 2.48155C4.71345 2.46936 4.7133 2.46344 4.71329 2.46162C4.71328 2.45982 4.71337 2.45418 4.71748 2.44249L4.24582 2.27655L3.77416 2.11061C3.69178 2.34478 3.69316 2.58846 3.77744 2.82156L4.24765 2.65155ZM4.24582 2.27655L4.71748 2.44249L4.78345 2.25499L4.31179 2.08905L3.84013 1.92311L3.77416 2.11061L4.24582 2.27655ZM4.31179 2.08905L4.78345 2.25499L4.84941 2.06749L4.37775 1.90155L3.90609 1.73561L3.84013 1.92311L4.31179 2.08905ZM4.37775 1.90155L4.84941 2.06749C4.85584 2.04922 4.86152 2.03556 4.86605 2.0258C4.87061 2.01597 4.87344 2.01132 4.87389 2.0106C4.87436 2.00985 4.87155 2.01449 4.8645 2.02233C4.85738 2.03026 4.84519 2.0423 4.82703 2.05517L4.53776 1.64735L4.2485 1.23952C4.05979 1.37337 3.96225 1.57598 3.90609 1.73561L4.37775 1.90155ZM4.53776 1.64735L4.82703 2.05517L4.92108 1.98847L4.63181 1.58064L4.34254 1.17281L4.2485 1.23952L4.53776 1.64735ZM4.63181 1.58064L4.92108 1.98847L5.01512 1.92176L4.72585 1.51394L4.43658 1.10611L4.34254 1.17281L4.63181 1.58064ZM4.72585 1.51394L5.01512 1.92176C5.00067 1.93202 4.99686 1.93128 5.01328 1.92534C5.02903 1.91964 5.05661 1.9116 5.0994 1.9036L5.0074 1.41213L4.9154 0.920669C4.76006 0.949747 4.58458 1.00114 4.43658 1.10611L4.72585 1.51394ZM5.0074 1.41213L5.0994 1.9036L5.2869 1.8685L5.1949 1.37703L5.1029 0.885571L4.9154 0.920669L5.0074 1.41213ZM5.1949 1.37703L5.2869 1.8685L5.4744 1.8334L5.3824 1.34194L5.2904 0.850472L5.1029 0.885571L5.1949 1.37703ZM5.3824 1.34194L5.4744 1.8334C5.53755 1.82158 5.59914 1.82175 5.6625 1.83399L5.7574 1.34308L5.85229 0.85217C5.66566 0.816091 5.47725 0.815495 5.2904 0.850472L5.3824 1.34194ZM5.7574 1.34308L5.6625 1.83399L5.85 1.87024L5.9449 1.37933L6.03979 0.888414L5.85229 0.85217L5.7574 1.34308ZM5.9449 1.37933L5.85 1.87024L6.0375 1.90648L6.1324 1.41557L6.22729 0.924659L6.03979 0.888414L5.9449 1.37933ZM6.1324 1.41557L6.0375 1.90648C6.17833 1.93371 6.31953 1.95394 6.46105 1.96712L6.5074 1.46927L6.55375 0.971427C6.44526 0.961325 6.33646 0.945761 6.22729 0.924659L6.1324 1.41557ZM6.5074 1.46927L6.46105 1.96712L6.64855 1.98458L6.6949 1.48673L6.74125 0.988885L6.55375 0.971427L6.5074 1.46927ZM6.6949 1.48673L6.64855 1.98458L6.83605 2.00204L6.8824 1.50419L6.92875 1.00634L6.74125 0.988885L6.6949 1.48673ZM6.8824 1.50419L6.83605 2.00204C6.98543 2.01594 7.13502 2.01884 7.28461 2.01069L7.2574 1.51143L7.23019 1.01217C7.12978 1.01764 7.02937 1.01571 6.92875 1.00634L6.8824 1.50419ZM7.2574 1.51143L7.28461 2.01069L7.47211 2.00047L7.4449 1.50121L7.41769 1.00195L7.23019 1.01217L7.2574 1.51143ZM7.4449 1.50121L7.47211 2.00047L7.65961 1.99025L7.6324 1.49099L7.60519 0.991732L7.41769 1.00195L7.4449 1.50121ZM7.6324 1.49099L7.65961 1.99025C7.7511 1.98526 7.84281 1.98941 7.93521 2.00289L8.0074 1.50813L8.07959 1.01337C7.92199 0.990375 7.76369 0.983095 7.60519 0.991732L7.6324 1.49099ZM8.0074 1.50813L7.93521 2.00289L8.12271 2.03025L8.1949 1.53549L8.26709 1.04073L8.07959 1.01337L8.0074 1.50813ZM8.1949 1.53549L8.12271 2.03025L8.31021 2.05761L8.3824 1.56285L8.45459 1.06809L8.26709 1.04073L8.1949 1.53549ZM8.3824 1.56285L8.31021 2.05761C8.50247 2.08566 8.69451 2.07443 8.88244 2.02589L8.7574 1.54178L8.63235 1.05766C8.57028 1.0737 8.51232 1.07651 8.45459 1.06809L8.3824 1.56285ZM8.7574 1.54178L8.88244 2.02589L9.06994 1.97745L8.9449 1.49334L8.81985 1.00923L8.63235 1.05766L8.7574 1.54178ZM8.9449 1.49334L9.06994 1.97745L9.25744 1.92902L9.1324 1.44491L9.00735 0.960802L8.81985 1.00923L8.9449 1.49334ZM9.1324 1.44491L9.25744 1.92902C9.2579 1.92891 9.25367 1.93004 9.24542 1.9304C9.23697 1.93076 9.22594 1.93024 9.21336 1.92777C9.18582 1.92235 9.16755 1.91105 9.16098 1.90596L9.46736 1.51082L9.77374 1.11569C9.54785 0.940535 9.27558 0.891518 9.00735 0.960802L9.1324 1.44491ZM9.46736 1.51082L9.16098 1.90596L9.30845 2.0203L9.61483 1.62516L9.92121 1.23003L9.77374 1.11569L9.46736 1.51082ZM9.61483 1.62516L9.30845 2.0203L9.45592 2.13464L9.7623 1.73951L10.0687 1.34437L9.92121 1.23003L9.61483 1.62516ZM9.7623 1.73951L9.45592 2.13464C9.44508 2.12624 9.41886 2.10109 9.40115 2.05642C9.38361 2.01218 9.38592 1.97782 9.38737 1.96804L9.88197 2.04135L10.3766 2.11466C10.3965 1.97988 10.3882 1.83271 10.3307 1.68785C10.2731 1.54257 10.1778 1.429 10.0687 1.34437L9.7623 1.73951ZM9.88197 2.04135L9.38737 1.96804L9.35958 2.15554L9.85418 2.22885L10.3488 2.30216L10.3766 2.11466L9.88197 2.04135ZM9.85418 2.22885L9.35958 2.15554L9.33179 2.34304L9.82639 2.41635L10.321 2.48966L10.3488 2.30216L9.85418 2.22885ZM9.82639 2.41635L9.33179 2.34304C9.30715 2.50931 9.30346 2.6764 9.32092 2.84335L9.81821 2.79135L10.3155 2.73935C10.3068 2.65629 10.3086 2.57339 10.321 2.48966L9.82639 2.41635ZM9.81821 2.79135L9.32092 2.84335L9.34052 3.03085L9.83781 2.97885L10.3351 2.92685L10.3155 2.73935L9.81821 2.79135ZM9.83781 2.97885L9.34052 3.03085L9.36013 3.21835L9.85742 3.16635L10.3547 3.11435L10.3351 2.92685L9.83781 2.97885ZM9.85742 3.16635L9.36013 3.21835C9.36494 3.26439 9.36008 3.31397 9.33912 3.37236L9.80969 3.54135L10.2803 3.71034C10.3491 3.51873 10.376 3.31831 10.3547 3.11435L9.85742 3.16635ZM9.80969 3.54135L9.33912 3.37236L9.27178 3.55986L9.74236 3.72885L10.2129 3.89784L10.2803 3.71034L9.80969 3.54135ZM9.74236 3.72885L9.27178 3.55986L9.20445 3.74736L9.67502 3.91635L10.1456 4.08534L10.2129 3.89784L9.74236 3.72885ZM9.67502 3.91635L9.20445 3.74736C9.14358 3.91683 9.10776 4.09144 9.10005 4.26976L9.59958 4.29135L10.0991 4.31294C10.1022 4.24126 10.1167 4.16587 10.1456 4.08534L9.67502 3.91635ZM9.59958 4.29135L9.10005 4.26976L9.09195 4.45726L9.59148 4.47885L10.091 4.50044L10.0991 4.31294L9.59958 4.29135ZM9.59148 4.47885L9.09195 4.45726L9.08384 4.64476L9.58337 4.66635L10.0829 4.68794L10.091 4.50044L9.59148 4.47885ZM9.58337 4.66635L9.08384 4.64476C9.0784 4.7706 9.07328 4.89645 9.06848 5.02229L9.56812 5.04135L10.0678 5.06041C10.0725 4.93625 10.0775 4.8121 10.0829 4.68794L9.58337 4.66635ZM9.56812 5.04135L9.06848 5.02229L9.06133 5.20979L9.56097 5.22885L10.0606 5.24791L10.0678 5.06041L9.56812 5.04135ZM9.56097 5.22885L9.06133 5.20979L9.05418 5.39729L9.55381 5.41635L10.0535 5.43541L10.0606 5.24791L9.56097 5.22885ZM9.55381 5.41635L9.05418 5.39729C9.04741 5.57461 9.06827 5.75012 9.11493 5.9222L9.5975 5.79135L10.0801 5.6605C10.0589 5.58258 10.0507 5.50809 10.0535 5.43541L9.55381 5.41635ZM9.5975 5.79135L9.11493 5.9222L9.16576 6.1097L9.64834 5.97885L10.1309 5.848L10.0801 5.6605L9.5975 5.79135ZM9.64834 5.97885L9.16576 6.1097L9.2166 6.2972L9.69918 6.16635L10.1818 6.0355L10.1309 5.848L9.64834 5.97885ZM9.69918 6.16635L9.2166 6.2972C9.25031 6.42153 9.27543 6.51587 9.29228 6.58128L9.77647 6.45658L10.2607 6.33187C10.2422 6.26031 10.2158 6.16117 10.1818 6.0355L9.69918 6.16635ZM9.77647 6.45658L9.29228 6.58128L9.31873 6.68401L9.80293 6.55931L10.2871 6.4346L10.2607 6.33187L9.77647 6.45658ZM9.80293 6.55931L9.31873 6.68401L9.34519 6.78674L9.82939 6.66203L10.3136 6.53733L10.2871 6.4346L9.80293 6.55931ZM9.82939 6.66203L9.34519 6.78674C9.44762 7.18445 9.83052 7.26504 9.98793 7.28259L10.0433 6.78567L10.0988 6.28875C10.0723 6.2858 10.0991 6.28412 10.1463 6.31139C10.1727 6.32665 10.2079 6.35244 10.241 6.39336C10.2752 6.43552 10.3001 6.485 10.3136 6.53733L9.82939 6.66203ZM10.0433 6.78567L9.98793 7.28259L10.1754 7.3035L10.2308 6.80658L10.2863 6.30966L10.0988 6.28875L10.0433 6.78567ZM10.2308 6.80658L10.1754 7.3035L10.3629 7.32441L10.4183 6.82749L10.4738 6.33057L10.2863 6.30966L10.2308 6.80658ZM10.4183 6.82749L10.3629 7.32441C10.4441 7.33346 10.5286 7.3536 10.617 7.38694L10.7933 6.91906L10.9697 6.45117C10.8081 6.39031 10.6426 6.3494 10.4738 6.33057L10.4183 6.82749ZM10.7933 6.91906L10.617 7.38694L10.8045 7.45759L10.9808 6.98971L11.1572 6.52183L10.9697 6.45117L10.7933 6.91906ZM10.9808 6.98971L10.8045 7.45759L10.992 7.52825L11.1683 7.06036L11.3447 6.59248L11.1572 6.52183L10.9808 6.98971ZM11.1683 7.06036L10.992 7.52825C11.2007 7.60687 11.4211 7.62796 11.6428 7.58298L11.5433 7.09297L11.4439 6.60296C11.4155 6.60871 11.386 6.60807 11.3447 6.59248L11.1683 7.06036ZM11.5433 7.09297L11.6428 7.58298L11.8303 7.54494L11.7308 7.05492L11.6314 6.56491L11.4439 6.60296L11.5433 7.09297ZM11.7308 7.05492L11.8303 7.54494L12.0178 7.50689L11.9183 7.01687L11.8189 6.52686L11.6314 6.56491L11.7308 7.05492ZM11.9183 7.01687L12.0178 7.50689C12.0661 7.49709 12.0666 7.50138 12.0392 7.49995C12.0253 7.49923 11.9777 7.49592 11.917 7.47074C11.8514 7.44355 11.7517 7.38184 11.6877 7.25846L12.1314 7.02802L12.5751 6.79758C12.4318 6.52154 12.1461 6.50417 12.0915 6.50132C11.9931 6.49618 11.8956 6.5113 11.8189 6.52686L11.9183 7.01687ZM12.1314 7.02802L11.6877 7.25846L11.7132 7.30765L12.1569 7.07721L12.6007 6.84677L12.5751 6.79758L12.1314 7.02802ZM12.1569 7.07721L11.7132 7.30765L11.7388 7.35684L12.1825 7.1264L12.6262 6.89596L12.6007 6.84677L12.1569 7.07721ZM12.1825 7.1264L11.7388 7.35684C11.6881 7.25934 11.6867 7.17281 11.6885 7.13511C11.6904 7.09454 11.6981 7.06841 11.6995 7.06373C11.7022 7.05489 11.6986 7.06888 11.6745 7.1144L12.1162 7.34868L12.5579 7.58296C12.595 7.51309 12.6331 7.43234 12.6579 7.3494C12.6703 7.30767 12.6842 7.24965 12.6874 7.18237C12.6904 7.11794 12.6854 7.00986 12.6262 6.89596L12.1825 7.1264ZM12.1162 7.34868L11.6745 7.1144L11.5827 7.28749L12.0244 7.52178L12.4661 7.75606L12.5579 7.58296L12.1162 7.34868ZM12.0244 7.52178L11.5827 7.28749L11.4909 7.46059L11.9326 7.69487L12.3743 7.92915L12.4661 7.75606L12.0244 7.52178ZM11.9326 7.69487L11.4909 7.46059C11.4715 7.49706 11.4487 7.52055 11.417 7.53964L11.6753 7.9678L11.9335 8.39596C12.1225 8.28194 12.2713 8.12347 12.3743 7.92915L11.9326 7.69487ZM11.6753 7.9678L11.417 7.53964L11.2515 7.63947L11.5097 8.06764L11.7679 8.4958L11.9335 8.39596L11.6753 7.9678ZM11.5097 8.06764L11.2515 7.63947L11.0859 7.73931L11.3442 8.16747L11.6024 8.59564L11.7679 8.4958L11.5097 8.06764ZM11.3442 8.16747L11.0859 7.73931C10.9021 7.85018 10.7544 8.00192 10.6481 8.18817L11.0824 8.43599L11.5166 8.6838C11.5387 8.64515 11.5655 8.61788 11.6024 8.59564L11.3442 8.16747ZM11.0824 8.43599L10.6481 8.18817L10.5518 8.35685L10.9861 8.60466L11.4204 8.85248L11.5166 8.6838L11.0824 8.43599ZM10.9861 8.60466L10.5518 8.35685L10.4556 8.52552L10.8899 8.77334L11.3241 9.02115L11.4204 8.85248L10.9861 8.60466ZM10.8899 8.77334L10.4556 8.52552C10.448 8.53883 10.4398 8.54919 10.4116 8.56118L10.6073 9.02126L10.8031 9.48135C11.0233 9.38767 11.2034 9.23275 11.3241 9.02115L10.8899 8.77334ZM10.6073 9.02126L10.4116 8.56118L10.2253 8.64043L10.4211 9.10051L10.6168 9.5606L10.8031 9.48135L10.6073 9.02126ZM10.4211 9.10051L10.2253 8.64043L10.0391 8.71968L10.2348 9.17976L10.4306 9.63985L10.6168 9.5606L10.4211 9.10051ZM10.2348 9.17976L10.0391 8.71968C9.85595 8.79758 9.69201 8.90825 9.55531 9.05429L9.92036 9.39597L10.2854 9.73764C10.3196 9.70109 10.3653 9.66761 10.4306 9.63985L10.2348 9.17976ZM9.92036 9.39597L9.55531 9.05429L9.42713 9.19125L9.79218 9.53292L10.1572 9.8746L10.2854 9.73764L9.92036 9.39597ZM9.79218 9.53292L9.42713 9.19125L9.29894 9.3282L9.66399 9.66987L10.029 10.0115L10.1572 9.8746L9.79218 9.53292ZM9.66399 9.66987L9.29894 9.3282C9.22441 9.40783 9.14616 9.4838 9.06415 9.55612L9.39488 9.93112L9.7256 10.3061C9.8315 10.2127 9.93266 10.1145 10.029 10.0115L9.66399 9.66987ZM9.39488 9.93112L9.06415 9.55612L8.92322 9.68042L9.25395 10.0554L9.58467 10.4304L9.7256 10.3061L9.39488 9.93112ZM9.25395 10.0554L8.92322 9.68042L8.78229 9.80471L9.11302 10.1797L9.44374 10.5547L9.58467 10.4304L9.25395 10.0554ZM9.11302 10.1797L8.78229 9.80471C8.62881 9.94007 8.51317 10.1055 8.4331 10.292L8.89255 10.4893L9.352 10.6865C9.37798 10.626 9.40932 10.5851 9.44374 10.5547L9.11302 10.1797ZM8.89255 10.4893L8.4331 10.292L8.35356 10.4773L8.813 10.6746L9.27245 10.8718L9.352 10.6865L8.89255 10.4893ZM8.813 10.6746L8.35356 10.4773L8.27401 10.6626L8.73346 10.8598L9.19291 11.0571L9.27245 10.8718L8.813 10.6746ZM8.73346 10.8598L8.27401 10.6626C8.25429 10.7085 8.2316 10.7337 8.20662 10.7518L8.50013 11.1566L8.79364 11.5614C8.97371 11.4308 9.10658 11.2582 9.19291 11.0571L8.73346 10.8598ZM8.50013 11.1566L8.20662 10.7518L8.05283 10.8634L8.34634 11.2681L8.63985 11.6729L8.79364 11.5614L8.50013 11.1566ZM8.34634 11.2681L8.05283 10.8634L7.89904 10.9749L8.19255 11.3797L8.48605 11.7844L8.63985 11.6729L8.34634 11.2681ZM8.19255 11.3797L7.89904 10.9749C7.76898 11.0692 7.6499 11.1756 7.54238 11.2941L7.91261 11.6301L8.28284 11.9662C8.34352 11.8993 8.41106 11.8388 8.48605 11.7844L8.19255 11.3797ZM7.91261 11.6301L7.54238 11.2941L7.41623 11.4331L7.78646 11.7691L8.15669 12.1052L8.28284 11.9662L7.91261 11.6301ZM7.78646 11.7691L7.41623 11.4331L7.29008 11.572L7.66031 11.9081L8.03054 12.2441L8.15669 12.1052L7.78646 11.7691ZM7.66031 11.9081L7.29008 11.572C7.22652 11.6421 7.16813 11.6932 7.11596 11.73L7.40366 12.1389L7.69136 12.5478C7.8132 12.4621 7.92591 12.3594 8.03054 12.2441L7.66031 11.9081ZM7.40366 12.1389L7.11596 11.73L6.98545 11.8218L7.27315 12.2307L7.56085 12.6396L7.69136 12.5478L7.40366 12.1389ZM7.27315 12.2307L6.98545 11.8218L6.85494 11.9136L7.14265 12.3225L7.43035 12.7315L7.56085 12.6396L7.27315 12.2307ZM7.14265 12.3225L6.85494 11.9136C6.8905 11.8886 6.93925 11.871 6.9903 11.87C7.03539 11.8691 7.05717 11.8816 7.04826 11.8774L6.83255 12.3285L6.61684 12.7795C6.85235 12.8922 7.15708 12.9237 7.43035 12.7315L7.14265 12.3225ZM6.83255 12.3285L7.04826 11.8774L6.86868 11.7915L6.65296 12.2426L6.43725 12.6936L6.61684 12.7795L6.83255 12.3285ZM6.65296 12.2426L6.86868 11.7915L6.68909 11.7056L6.47337 12.1567L6.25766 12.6078L6.43725 12.6936L6.65296 12.2426ZM6.47337 12.1567L6.68909 11.7056C6.64175 11.683 6.61216 11.6564 6.59 11.6254L6.18329 11.9163L5.77657 12.2071C5.90174 12.3822 6.06554 12.5159 6.25766 12.6078L6.47337 12.1567ZM6.18329 11.9163L6.59 11.6254L6.4795 11.4709L6.07279 11.7618L5.66608 12.0526L5.77657 12.2071L6.18329 11.9163ZM6.07279 11.7618L6.4795 11.4709L6.369 11.3164L5.96229 11.6072L5.55558 11.8981L5.66608 12.0526L6.07279 11.7618ZM5.96229 11.6072L6.369 11.3164C6.31154 11.236 6.25913 11.1486 6.21204 11.0536L5.76403 11.2756L5.31601 11.4976C5.38594 11.6387 5.4657 11.7724 5.55558 11.8981L5.96229 11.6072ZM5.76403 11.2756L6.21204 11.0536L6.12428 10.8765L5.67626 11.0985L5.22825 11.3205L5.31601 11.4976L5.76403 11.2756ZM5.67626 11.0985L6.12428 10.8765L6.03651 10.6994L5.5885 10.9214L5.14049 11.1434L5.22825 11.3205L5.67626 11.0985ZM5.5885 10.9214L6.03651 10.6994C5.94554 10.5158 5.818 10.3574 5.65419 10.2321L5.35043 10.6293L5.04666 11.0264C5.08327 11.0544 5.11444 11.0908 5.14049 11.1434L5.5885 10.9214ZM5.35043 10.6293L5.65419 10.2321L5.50388 10.1172L5.20011 10.5143L4.89635 10.9115L5.04666 11.0264L5.35043 10.6293ZM5.20011 10.5143L5.50388 10.1172L5.35357 10.0022L5.0498 10.3994L4.74604 10.7965L4.89635 10.9115L5.20011 10.5143ZM5.0498 10.3994L5.35357 10.0022C5.28336 9.9485 5.22074 9.88818 5.1651 9.8208L4.77959 10.1392L4.39407 10.4576C4.4983 10.5838 4.61583 10.6969 4.74604 10.7965L5.0498 10.3994ZM4.77959 10.1392L5.1651 9.8208L5.0452 9.67562L4.65968 9.99402L4.27417 10.3124L4.39407 10.4576L4.77959 10.1392ZM4.65968 9.99402L5.0452 9.67562L4.92529 9.53045L4.53978 9.84884L4.15426 10.1672L4.27417 10.3124L4.65968 9.99402ZM4.53978 9.84884L4.92529 9.53045C4.79744 9.37564 4.64017 9.25481 4.4606 9.16724L4.24143 9.61664L4.02226 10.066C4.08062 10.0945 4.12224 10.1285 4.15426 10.1672L4.53978 9.84884ZM4.24143 9.61664L4.4606 9.16724L4.28216 9.08021L4.06299 9.52962L3.84382 9.97902L4.02226 10.066L4.24143 9.61664ZM4.06299 9.52962L4.28216 9.08021L4.10372 8.99319L3.88455 9.44259L3.66538 9.892L3.84382 9.97902L4.06299 9.52962ZM3.88455 9.44259L4.10372 8.99319C4.0791 8.98118 4.06803 8.96958 4.05732 8.94921L3.6148 9.18198L3.17229 9.41475C3.28332 9.62583 3.45208 9.78797 3.66538 9.892L3.88455 9.44259ZM3.6148 9.18198L4.05732 8.94921L3.96601 8.77562L3.52349 9.00839L3.08098 9.24116L3.17229 9.41475L3.6148 9.18198ZM3.52349 9.00839L3.96601 8.77562L3.8747 8.60204L3.43218 8.8348L2.98967 9.06757L3.08098 9.24116L3.52349 9.00839ZM3.43218 8.8348L3.8747 8.60204C3.77349 8.40963 3.62818 8.25118 3.44303 8.13525L3.17769 8.55904L2.91234 8.98282C2.94478 9.00313 2.96913 9.02852 2.98967 9.06757L3.43218 8.8348ZM3.17769 8.55904L3.44303 8.13525L3.27984 8.03308L3.0145 8.45686L2.74915 8.88064L2.91234 8.98282L3.17769 8.55904ZM3.0145 8.45686L3.27984 8.03308L3.11665 7.9309L2.85131 8.35468L2.58597 8.77846L2.74915 8.88064L3.0145 8.45686ZM2.85131 8.35468L3.11665 7.9309C3.06867 7.90085 3.03161 7.8644 3.00149 7.81841L2.58324 8.0924L2.16499 8.36638C2.27471 8.53388 2.41636 8.67227 2.58597 8.77846L2.85131 8.35468ZM2.58324 8.0924L3.00149 7.81841L2.89661 7.65831L2.47836 7.93229L2.06011 8.20628L2.16499 8.36638L2.58324 8.0924ZM2.47836 7.93229L2.89661 7.65831L2.79173 7.4982L2.37348 7.77219L1.95523 8.04617L2.06011 8.20628L2.47836 7.93229ZM2.37348 7.77219L2.79173 7.4982C2.69401 7.34903 2.57572 7.21738 2.43756 7.10512L2.12225 7.49317L1.80694 7.88121C1.86392 7.92751 1.91311 7.98187 1.95523 8.04617L2.37348 7.77219ZM2.12225 7.49317L2.43756 7.10512L2.29122 6.98621L1.97591 7.37426L1.6606 7.7623L1.80694 7.88121L2.12225 7.49317ZM1.97591 7.37426L2.29122 6.98621L2.14488 6.8673L1.82957 7.25534L1.51426 7.64339L1.6606 7.7623L1.97591 7.37426ZM1.82957 7.25534L2.14488 6.8673C2.13604 6.86012 2.14006 6.86223 2.15015 6.87401C2.15872 6.88401 2.18689 6.91843 2.20848 6.97683C2.23216 7.04085 2.24875 7.13801 2.21679 7.24781C2.18543 7.35557 2.12202 7.42482 2.07608 7.4619L1.76206 7.07281L1.44805 6.68371C1.37583 6.742 1.29552 6.83476 1.25664 6.96834C1.21717 7.10395 1.23563 7.22923 1.27056 7.32368C1.33042 7.48554 1.45008 7.59124 1.51426 7.64339L1.82957 7.25534ZM1.76206 7.07281L2.07608 7.4619L2.15492 7.39827L1.8409 7.00918L1.52688 6.62009L1.44805 6.68371L1.76206 7.07281ZM1.8409 7.00918L2.15492 7.39827L2.23376 7.33465L1.91974 6.94555L1.60572 6.55646L1.52688 6.62009L1.8409 7.00918ZM1.91974 6.94555L2.23376 7.33465C2.1668 7.38868 2.10446 7.39994 2.08505 7.40226C2.06662 7.40446 2.06917 7.40105 2.10245 7.40669L2.18608 6.91374L2.2697 6.42078C2.11646 6.39478 1.83555 6.37098 1.60572 6.55646L1.91974 6.94555ZM2.18608 6.91374L2.10245 7.40669L2.28995 7.4385L2.37358 6.94554L2.4572 6.45259L2.2697 6.42078L2.18608 6.91374ZM2.37358 6.94554L2.28995 7.4385L2.47745 7.47031L2.56108 6.97735L2.6447 6.4844L2.4572 6.45259L2.37358 6.94554ZM2.56108 6.97735L2.47745 7.47031C2.6632 7.50182 2.84997 7.49878 3.03468 7.46162L2.93608 6.97144L2.83747 6.48126C2.77218 6.4944 2.70895 6.4953 2.6447 6.4844L2.56108 6.97735ZM2.93608 6.97144L3.03468 7.46162L3.22218 7.42391L3.12358 6.93372L3.02497 6.44354L2.83747 6.48126L2.93608 6.97144ZM3.12358 6.93372L3.22218 7.42391L3.40968 7.38619L3.31108 6.89601L3.21247 6.40583L3.02497 6.44354L3.12358 6.93372ZM3.31108 6.89601L3.40968 7.38619C3.50346 7.36732 3.59605 7.35794 3.6879 7.3576L3.68608 6.85761L3.68426 6.35761C3.52611 6.35818 3.3687 6.3744 3.21247 6.40583L3.31108 6.89601ZM3.68608 6.85761L3.6879 7.3576L3.8754 7.35692L3.87358 6.85692L3.87176 6.35693L3.68426 6.35761L3.68608 6.85761ZM3.87358 6.85692L3.8754 7.35692L4.0629 7.35624L4.06108 6.85624L4.05926 6.35624L3.87176 6.35693L3.87358 6.85692ZM4.06108 6.85624L4.0629 7.35624C4.11886 7.35603 4.13908 7.35829 4.13718 7.35804C4.1352 7.35777 4.1284 7.35681 4.11816 7.35456C4.10874 7.35248 4.08975 7.34788 4.06545 7.33872C4.04362 7.33048 3.99925 7.31187 3.95025 7.2747C3.90106 7.23739 3.82268 7.16228 3.78205 7.03768L4.25742 6.88268L4.73279 6.72769C4.65399 6.48601 4.44124 6.41168 4.41821 6.403C4.35733 6.38005 4.30149 6.37114 4.27064 6.36698C4.2033 6.35791 4.12829 6.35599 4.05926 6.35624L4.06108 6.85624ZM4.25742 6.88268L3.78205 7.03768L3.79089 7.0648L4.26626 6.90981L4.74163 6.75481L4.73279 6.72769L4.25742 6.88268ZM4.26626 6.90981L3.79089 7.0648L3.79974 7.09192L4.27511 6.93693L4.75048 6.78193L4.74163 6.75481L4.26626 6.90981ZM4.27511 6.93693L3.79974 7.09192C3.80865 7.11926 3.83202 7.18474 3.88652 7.25259C3.94663 7.32742 4.07313 7.43589 4.26666 7.44023C4.44121 7.44414 4.55831 7.35912 4.60452 7.31962C4.655 7.27648 4.68545 7.23302 4.69898 7.21253C4.74398 7.14436 4.76526 7.07376 4.76792 7.06561C4.78403 7.01628 4.7998 6.95305 4.81453 6.88962L4.32748 6.77655L3.84043 6.66348C3.83383 6.69194 3.82838 6.71416 3.82402 6.73088C3.81938 6.7487 3.8172 6.75557 3.81732 6.75518C3.81736 6.75506 3.81954 6.74827 3.82391 6.73762C3.82619 6.73203 3.83906 6.70003 3.86442 6.66162C3.87648 6.64335 3.90556 6.60154 3.95476 6.55949C3.99969 6.52108 4.11561 6.43659 4.28906 6.44048C4.48149 6.44479 4.60699 6.55268 4.66617 6.62637C4.71976 6.69308 4.7423 6.75686 4.75048 6.78193L4.27511 6.93693ZM4.32748 6.77655L4.81453 6.88962L4.85806 6.70212L4.37101 6.58905L3.88396 6.47598L3.84043 6.66348L4.32748 6.77655Z"
        fill="#795B4E"
      />
    </svg>
  ),

  Lightning: ({ className, ...props }: SVGProps<SVGSVGElement>) => (
    <svg
      width="8"
      height="10"
      viewBox="0 0 7.94166 9.77459"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M4.34039 0.266897C4.96429 -0.357006 6.02069 0.196646 5.86285 1.06475L5.3482 3.8958H7.03961C7.84142 3.8958 8.2433 4.86594 7.67633 5.43291L3.60113 9.50811C2.9773 10.1313 1.92138 9.57788 2.07867 8.71026L2.59332 5.8792H0.901913C0.100186 5.8792 -0.301513 4.90909 0.265195 4.34209L4.34039 0.266897Z"
        fill="currentColor"
      />
    </svg>
  ),
};
